import Epever from './epever.png';
import Goodwe from './goodwe.png';

const DeviceImages: DevicesGenericMapper = {
  epever: Epever,
  goodwe: Goodwe,
};

export default DeviceImages;
